import { type PageProps } from "gatsby";
import { type FC } from "react";
import { LoggedOutBar } from "../../components/AppBar/Bars";
import GuidepostSimplified from "../../components/Rozcestnik/GuidepostSimplified";
import { Seo } from "../../components/SEO";
import withRedirectWhenLoggedIn from "../../highOrderComponents/withRedirectWhenLoggedIn";

export const AppBar: FC = () => <LoggedOutBar />;

const AuthChoicePage: FC<PageProps> = (pageProps) => {
	return <GuidepostSimplified pageProps={pageProps} />;
}

export default withRedirectWhenLoggedIn(AuthChoicePage);

export const Head: FC = () => <Seo title="Přihlášení/Registrace" />;
